$(document).ready(function() {
    function toggleAlertState(globalAlert, expanded, noticeMessage, moreInfo) {
        // const toggledProps = expanded ? { height: 'auto', minHeight: '70px' } : { height: '70px', minHeight: 'auto' };
        // globalAlert.css(toggledProps).toggleClass('global-alert--expanded', expanded);
        globalAlert.toggleClass('global-alert--expanded', expanded);
        noticeMessage.slideToggle();
        moreInfo.html(expanded ? '<p>Less Information</p><span></span>' : '<p>More Information</p><span></span>');
        moreInfo.children('span').css({ transform: `rotate(${expanded ? 270 : 90}deg)`, top: expanded ? '-2px' : '0' });
    }

    $('.global-alert').each(function() {
        const globalAlert = $(this);
        console.log('Global alert data:', globalAlert.data());
        let { actionurl: baseurl, currentlink: currentLink } = globalAlert.data();

        if (currentLink[0] === '/') {
            currentLink = currentLink.slice(1);
        }

        const noticeMessage = globalAlert.find('.notice-message');
        const moreInfo = globalAlert.find('.more');

        globalAlert.find('.close').on('click', function() {
            globalAlert.remove();

            // Hacky scroll to trigger re-layout
            $(window).scrollTop($(window).scrollTop() + 1);
            $(window).scrollTop($(window).scrollTop() - 1);

            const alertID = globalAlert.attr('id');
            const closeUrl = `${baseurl}/${currentLink}/closeAlert`.replace(/([^:]\/)\/+/g, "$1");
            console.log('Close url:', closeUrl);
    
            $.post(closeUrl, { id: alertID }).done(function(response) {
                console.log(response);
            });
        });

        moreInfo.on('click', function(evt) {
            evt.preventDefault();
            const expanded = globalAlert.hasClass('global-alert--expanded');
            toggleAlertState(globalAlert, !expanded, noticeMessage, moreInfo);
        });
    });
});